<div id="file-uploader" fileDnD (onFileDropped)="uploadFile($event)">
  <div class="row mb-2">
    <div *ngIf="!file" class="col-xs-12">
      <div class="well my-drop-zone">
        <div>Drop files to upload</div>
        <div class="small">or</div>
        <button type="button" class="btn btn-outline" style="margin-top:6px;">
          <label for="fileUploader">
            Select Files
            <input hidden id="fileUploader" type="file" #fileInput (change)="uploadFile($event.target.files)" multiple style="display: none;">
          </label>
        </button>
      </div>
        <div *ngFor="let error of fileUploadErrors" class="alert alert-danger text-center">{{error.message}}</div>
    </div>
  </div>
  <div *ngIf="nonUniqueFilename" class="row">Filenames must be unique</div>
  <div class="row">
    <div class="col-xs-12">
      <table class="table uploader" aria-describedby="fileUploaderLabel">
        <thead>
          <tr>
            <th class="col-sm-6" scope="col" id="fileUploaderLabel">New Documents</th>
            <th class="col-sm-3" scope="col">Size</th>
            <th class="col-sm-3" scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let file of files; index as i" class="docs-list">
            <td scope="row" class="pl-0">{{ file.file.name }}</td>
            <td scope="row" nowrap>{{ file.file.size/1024/1024 | number:'.2' }} MB</td>
            <td scope="row" nowrap class="text-right pr-1">
              <button type="button" class="btn btn-danger" (click)="deleteAttachment(i)"><i class="glyphicon glyphicon-trash" title="Delete"></i></button>
            </td>
          </tr>
          <tr *ngFor="let upload of queuedUploads" class="docs-list">
            <td scope="row" class="pl-0">{{ upload.name }}</td>
            <td scope="row" nowrap>{{ upload.size/1024/1024 | number:'.2' }} MB</td>
            <td  scope="row" class="text-center" style="vertical-align: middle;">
              <div class="progress mb-0" >
                <div class="progress-bar" [ngStyle]="{'width.%': upload.progress}"></div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
